module.exports = __webpack_public_path__ + "img/loyalty.4e6ee702.png";